import { api } from "./axios";

export interface AuthStatus {
    isAuthenticated: boolean;
    isConcierge: boolean;
}

let authStatus: AuthStatus | null = { isAuthenticated: false, isConcierge: false };

export const checkAuthStatus = async (): Promise<AuthStatus> => {
    try {
        const res = await api.get("/authentication/is_verified");

        // If the response status is OK and the user is verified
        if (res?.status === 200 && res?.data?.status === "ok") {
            authStatus = {
                isAuthenticated: true,
                isConcierge: res.data?.is_concierge === true,
            };
        } else {
            // If not authenticated, set cache to false
            authStatus = {
                isAuthenticated: false,
                isConcierge: false,
            };
        }
    } catch (error) {
        console.log("Error checking auth status", error);
        authStatus = { isAuthenticated: false, isConcierge: false }; // Set to false on error
    }

    // Return the cached or fresh status
    return authStatus!;
};

export const invalidateAuth = () => {
    authStatus = { isAuthenticated: false, isConcierge: false };
};
